export enum StorageTypeId {
  S3 = 1,
  LONGHORN = 2,
  LOCAL = 3,
}

export const STORAGE_TYPES = [
  { id: StorageTypeId.S3, name: 'S3', label: 'S3 Storage', description: 'Object storage' },
] as const

export const getStorageTypeById = (id: number) => {
  return STORAGE_TYPES.find(type => type.id === id)
}

export const getStorageTypeByName = (name: string) => {
  return STORAGE_TYPES.find(type => type.name.toLowerCase() === name.toLowerCase())
}